module.exports = __webpack_public_path__ + "lp/img/up-icon-beginner.1c8a7069.svg";